export const EmissionImpactIntelligenceTab = () => {
  return "";
}